<template>
  <div  :style="{width:width,height:height,border:border,background:background}">

  </div>
</template>

<script>
  export default {
    props: {
      width: {
        type: String,
        default: '400px'
      },
      height: {
        type: String,
        default: '300px'
      },
      border:{
        type:String,
        default:'1px solid #ffffff'
      },
      background:{
        type:String,
        default:'transparent'
      }
    },
    data() {
      return {
      }
    },
    mounted() {},
    computed: {

    },
    methods: {
    }
  }
</script>

<style scoped="scoped" lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/box/customBox.vue